import { render } from "./LoginView.vue?vue&type=template&id=46cd03a4&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "@/assets/css/views/LoginView.scss?vue&type=style&index=0&id=46cd03a4&lang=scss&scoped=true"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cd03a4"]])

export default __exports__